<template>
  <div>
    <div v-if="isList">
      <h2 style="margin: 20px">用户角色权限</h2>
      <md-form :inline="true" :model="formHead" class="auto-form-inline auto-form-02 auto-form-03" @keydown.enter.native="onSubmit('init')">
        <md-row :gutter="20" >
            <md-col :span="23" >
               <md-row :gutter="20">
                  <md-col :span="6" >
                    <md-form-item label="用户编码">
                      <md-input v-model="formHead.userCode" placeholder="请输入用户编码" clearable @clear="onSubmit('init')"></md-input>
                    </md-form-item>
                  </md-col>
                  <md-col :span="6" >
                      <md-form-item label="角色编码">
                        <md-input v-model="formHead.roleCode" placeholder="请输入角色编码" clearable @clear="onSubmit('init')"></md-input>
                      </md-form-item>
                  </md-col>
                  <md-col :span="6" >
                   <md-form-item label="状态" >
                      <md-select v-model="formHead.status" clearable @clear="onSubmit('init')">
                        <md-option v-for='item of statusOptions' :key="item.value" :label="item.label" :value="item.value"></md-option>
                      </md-select>
                    </md-form-item>
                  </md-col>
               </md-row>
            </md-col>
            <md-col :span="1">
                <md-form-item>
                  <md-button style="margin: 20px" type="primary" @click="onSubmit('init')">查询</md-button>
                </md-form-item>
            </md-col>
        </md-row>
      </md-form>
      <md-button style="margin-top: 20px" type="primary" @click="cleanRedis" class="mr20">清除缓存</md-button>
      <md-button style="margin-top: 20px" type="primary" @click="importExcel" class="mr20">导入</md-button>
      <mn-btns style="margin-top: 20px" :btnList="listBtns" class="mn-btns" />
      <md-table ref="list" :data="tableData" style="width: 100%; margin-bottom: 20px" :height="height">
        <md-table-column type="index" width="50"></md-table-column>
        <md-table-column prop="userCode" label="用户编码" minWidth="200"></md-table-column>
        <md-table-column prop="roleCode" label="角色编码" minWidth="200"></md-table-column>
        <md-table-column prop="roleNameZh" label="角色名称" minWidth="200"></md-table-column>
        <md-table-column prop="descZh" label="角色描述" minWidth="200"></md-table-column>
        <!-- <md-table-column prop="createUserName" label="操作人" minWidth="140"></md-table-column> -->
        <md-table-column prop="status" label="角色状态" minWidth="100">
          <template slot-scope="scope">
            {{ scope.row.status === "Y" ? "有效" : "无效" }}
          </template>
        </md-table-column>
        <md-table-column prop="deleteFlag" label="是否删除" minWidth="100">
          <template slot-scope="scope">
            {{ scope.row.deleteFlag == "0" ? "正常" : "删除" }}
          </template>
        </md-table-column>
        <md-table-column prop="updateTime" label="同步时间" minWidth="200"></md-table-column>
        <!-- <md-table-column label="操作" minWidth="300">
          <template slot-scope="scope">
            <template v-for="item in btnList">
              <md-button @click="item.handel(scope.row)" :key="item.id" class="editBtn">{{ item.label }}</md-button>
            </template>
          </template>
        </md-table-column> -->
      </md-table>
      <div>
        <md-pagination
          style="float: right"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSetting.size"
          :current-page="pageSetting.current"
          layout="total, prev, pager, next, sizes,jumper"
          :total="pageSetting.total"
        ></md-pagination>
      </div>
    </div>
    <div v-if="!isList">
      <setRole
        :row="roleRow"
        @back="
          () => {
            this.isList = true;
            this.onSubmit();
          }
        "
      />
    </div>
    <md-dialog
            title="清除权限缓存"
            :fullscreen="false"
            :visible.sync="dialogVisible"
            width="30%"
            v-dialogDrag
        >
        <md-form :model="form" @keydown.enter.native="makeSure">
                <md-form-item label="MIP账户" :label-width="'80'">
                    <md-input v-model="form.mipText" style="width:60%;"></md-input>
                </md-form-item>
          </md-form>
            <span slot="footer" class="dialog-footer">
                <md-button size="small" @click="cancelDialog">取消</md-button>
                <md-button size="small" type="primary" @click="makeSure" >确定</md-button>
            </span>
    </md-dialog>
    <md-dialog title="选择导入文件" v-dialogDrag :fullscreen="false" :visible.sync="dialogFormVisible" width="30%">
      <div style="margin-top: -20px; float: right;">
        <md-button type="primary" @click="downloadFileFlex"> 点击下载角色管理导入模板 </md-button>
      </div>
      <md-form style="margin-top: -20px; float: left;">
        <md-upload
          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          action='/gscint/userRole/importUserRole'
          :multiple='false'
          :show-file-list='false'
          :with-credentials='true'
          :on-success='uploadExcel'
        >
          <md-button size="small" type="primary" icon='el-icon-upload'>上传附件</md-button>
        </md-upload>
      </md-form>
      <!-- <div slot="footer" class="dialog-footer">
        <el-button @click='expTemplate' v-show="this.form.billType == 10">下载模板</el-button>
      </div> -->
    </md-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import mnBtns from '../MnBtns/index.vue';


export default {
  name: 'role-manage',
  components: { mnBtns },
  mixins: [],
  data() {
    return {
      dialogFormVisible: false,
      tableData: [],
      height: null,
      btnList: [
        { label: '修改', id: 2, handel: this.edit },
        { label: '删除', id: 3, handel: this.delete },
        { label: '查看', id: 4, handel: this.check },
      ],
      formHead: {
        userCode: null,
        roleCode: null,
        ouName: null,
        roleType: null,
        status: null,

      },
      typeOptions: [
        { label: '全类型', value: 'ALL' },
        { label: '投资', value: 'INVESTMENT' },
        { label: '备件', value: 'SPARE' },
      ],
      statusOptions: [
        { label: '生效', value: 'Y' },
        { label: '无效', value: 'N' },
      ],
      isList: true,
      pageSetting: {
        current: 1,
        size: 10,
        total: 0,
      },
      listBtns: [
        // {
        //   name: '新增',
        //   handle: this.add,
        // },
        {
          name: '导出',
          handle: this.export,
        },
      ],
      dialogVisible: false,
      roleRow: {},
      form: {
        mipText: null,
      },
    };
  },

  mounted() {
    // this.$api.global.selectDict({
    //   dictionaryCode: 'SYSTEM_ROLE_TYPE',
    //   entryLanguage: 'zh-CN',
    // }).then(res => {
    //   this.options = res;
    // });
    this.queryList();
    const table = this.$refs.list;
    const tops = table.$el.getBoundingClientRect().top;
    if (tops > 0) {
      this.height = window.innerHeight - tops - 80 + 'px';
    }
  },

  methods: {
    // -------------------------初始化----------------------------
    // 查询
    queryList(params = {}) {
      axios
        .post('/gscint/userRole/queryUserRoleAllPage', {
          current: this.pageSetting.current,
          ...params,
          size: this.pageSetting.size || 20,
        })
        .then((res) => {
          if (res.data.data.code === '1') {
            this.tableData = res.data.data.datas.list;
            this.pageSetting.total = res.data.data.datas.total;
          } else {
            this.$MdMessage.warning(res.data.data.datas);
          }
        });
    },
    handleSizeChange(val) {
      this.pageSetting.size = val;
      this.onSubmit();
    },
    handleCurrentChange(val) {
      this.pageSetting.current = val;
      this.onSubmit();
    },
    onSubmit(type) {
      if (type === 'init') {
        this.pageSetting.current = 1;
      }
      this.queryList(this.formHead);
    },
    downloadFile(data, filename) {
      if (!data) {
        return;
      }
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement('a');
      link.style.display = 'none';
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    // 导出按钮
    export() {
      const params = {
        current: this.pageSetting.current,
        size: this.pageSetting.size,
        userCode: this.formHead.userCode,
        roleCode: this.formHead.roleCode,
        ouName: this.formHead.ouName,
        roleType: this.formHead.roleType,
        status: this.formHead.status,
      };
      axios({
        url: '/gscint/userRole/export',
        method: 'post',
        data: params,
        headers: { 'content-type': 'application/json; charset=utf-8' },
        responseType: 'blob',
      }).then((res) => {
        this.downloadFile(res.data, '角色权限.xlsx');
      });
    },
    importExcel() {
      this.dialogFormVisible = true;
    },
    // 下载导入模板
    downloadFileFlex() {
      axios({
        url: '/gscint/userRole/downLoadExample',
        method: 'get',
        headers: { 'content-type': 'application/json; charset=utf-8' },
        responseType: 'blob',
      }).then((res) => {
        this.downloadFile(res.data, '角色权限导入模板.xlsx');
      });
    },
    // 导入模板
    uploadExcel(res) {
      if (res.success) {
        this.dialogFormVisible = false;
        this.$MdMessage.success('导入成功!');
        this.queryList();
      } else {
        this.dialogFormVisible = false;
        this.$MdMessage.warning(res.msg);
      }
    },
    // 清理权限缓存
    cleanRedis() {
      this.dialogVisible = true;
    },
    cancelDialog() {
      this.dialogVisible = false;
      this.form.mipText = null;
    },
    makeSure() {
      // 1-1 清理权限缓存
      const s1 = axios
        .get('/gscint/userRole/cleanRedis', {
          params: {
            mip: this.form.mipText,
          },
        });
      const s2 = axios
        .get('/gscint/menu/cleanRedis', {
          params: {
            mip: this.form.mipText,
          },
        });
      Promise.all([s1, s2]).then(res => {
        if (res[0].data.data.code === '1') {
          this.$MdMessage.success('用户权限缓存清理成功');
        } else {
          this.$MdMessage.warning(res[0].data.data.datas);
        }
        if (res[1].data.data.code === '1') {
          setTimeout(() => {
            this.$MdMessage.success('菜单缓存清理成功');
            this.dialogVisible = false;
            this.form.mipText = null;
          }, 500);
        } else {
          setTimeout(() => {
            this.$MdMessage.warning(res[1].data.data.datas);
          }, 500);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.mn-btns {
  display: inline-block;
  width: auto;
}
.title {
  /deep/.head-title {
    font-size: 20px;
  }
}
.mr20{
  margin-right:20px;
  margin-left: 10px;
}
.editBtn {
  border: none;
  background: rgba(0, 0, 0, 0);
  padding: 0;
  margin-right: 8px;
  color: rgb(86, 163, 250);
  &:hover {
    background: rgba(0, 0, 0, 0);
    color: rgb(124, 185, 255);
  }
}
</style>
<style lang="less">
.auto-form-inline {
  height: 54px;
  display: flex;
  align-items: center;
  margin-left: 10px;
  .el-form-item {
    margin-bottom: 0;
  }
}
.auto-form-02 {
  .el-form-item {
    .el-form-item__label {
      padding-right: 8px;
    }
  }
}
.auto-form-03{
  margin-top:20px;
  margin-bottom: 10px;
}
.mt10{
  margin-top:10px;
}

</style>
